import React, {useContext} from 'react';
import {Button, Layout} from 'antd';
import {withRouter} from 'react-router-dom';
import {Arguments} from '../../views/sandbox/common/Arguments';
import {PostToJava} from '../../views/sandbox/common/ApiMethod';
import {sideMenuContext} from '../../router/IndexRouter';
import './index.css';

const {Header} = Layout;

function TopHeader() {
	const {setSideMenu} = useContext(sideMenuContext);
	const logoutMethod = () => {
		// 回到登录页
		window.open(Arguments.reactUrl + '/login', '_self');
		sessionStorage.removeItem('shadow');
		setSideMenu([]);    // 将页面上方的 Tabs 标签清空
		// 请求用户中心的退出登录接口
		const token = sessionStorage.getItem('userToken');
		const postApi = Arguments.host + '/society_organization/logout/author!logout.do';
		PostToJava(postApi, {Token: token}).then(res => {
			// 无论是否成功都要注销
			sessionStorage.clear();
			if (res?.data.code === 1) {
				// console.log("退出登录成功");
			}
		});
	};

	const nickname = sessionStorage.getItem('ghost');

	const color = nickname === '管理员' ? '#426374' : '#5073E4';
	const headerClass = nickname === '管理员' ? 'header' : 'topHeader';

	return (
		<Header style={{padding: '0 16px', backgroundColor: color}}>
			<div className={headerClass}>
				<div style={{float: 'right'}}>
                    <span style={{marginRight: 20, color: '#fff', fontSize: 18}}>
                        欢迎
                        <span style={{color: 'orange'}}>{nickname}</span>
                        回来
                    </span>
					<Button type="link" style={{fontSize: 18}} danger onClick={() => logoutMethod()}>退出登录</Button>
				</div>
			</div>
		</Header>
	);
}

//  使用 export default withRouter() 将一个组件包裹起来后，该组件就可以访问到路由相关的属性，并且在路由发生变化时，也能够重新渲染组件。
//  这对于需要在组件中获取当前路由信息或者进行路由导航的情况非常有用。
export default withRouter(TopHeader);
